import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../lib/domain';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    await authApi.forgotPassword(email).catch(() => undefined);
    setSent(true);
  }

  return (
    <div className="stack">
      <h1>Passwort vergessen</h1>
      {sent ? (
        <p className="card">Falls die Adresse existiert, wurde eine E-Mail mit einem Link zum Zurücksetzen versendet.</p>
      ) : (
        <form className="stack card" onSubmit={onSubmit}>
          <div className="field">
            <label htmlFor="email">E-Mail-Adresse</label>
            <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <button className="primary" type="submit">
            Link senden
          </button>
        </form>
      )}
      <Link to="/login">Zurück zur Anmeldung</Link>
    </div>
  );
}
